interface SectionHeadingProps {
  tag: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ tag, title, desc, align = "left" }: SectionHeadingProps) {
  const alignCls = align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col ${alignCls} ${align === "center" ? "max-w-3xl mx-auto" : "max-w-3xl"}`}>
      <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-label">
        <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
        {tag}
      </span>
      <h2 className="mt-4 font-heading font-bold text-foreground-950 text-2xl md:text-3xl leading-snug">
        {title}
      </h2>
      {desc && (
        <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">{desc}</p>
      )}
    </div>
  );
}